export default function () {
  return {
    sliders: null,
    popupSlide: null,
  };
}
